import axios from "axios";

export default {
    ExerciseGetByIds: async function (ids, callback) {
        // const URLString = ids.map((value, index) => `ids[${index}]=${value}`).join('&');

        await axios.get('/exercises?' + new URLSearchParams({
            ids: ids,
        }).toString(), {}, {
            withCredentials: true
        })
        .then(response => callback(response.data))
        .catch(error => {
            console.error("There was an error! ex get by ids", error);
        });
    },
    ExerciseGetById: async function (id, callback)  {
        await axios.get('/exercises/'+id, {}, {
            withCredentials: true
        })
        .then(response => callback(response.data))
        .catch(error => {
            console.error("There was an error! ex get by id", error);
        });
    },
    CheckSentence: async function (id, prevTasks, task, userInput, audioBlob, score, voiceMode, callback, errCallback)  {
        await axios.postForm('/exercises/'+id+'/check', {
            prev_tasks: JSON.stringify(prevTasks),
            task: task,
            user_input: userInput,
            external_score: score,
            file_buffer: audioBlob,
            voice_mode: voiceMode,
        }, {
            withCredentials: true
        })
        .then(response => callback(response.data))
        .catch(error => {
            console.error("There was an error! check sentence", error);
            errCallback(error.response.data)
        });
    },
    GetWordHint: async function (id, wordIdx, task, score, callback, errCallback)  {
        await axios.post('/exercises/'+id+'/hint', {
            word_index: wordIdx,
            task: task,
            external_score: score,
        }, {
            withCredentials: true
        })
        .then(response => callback(response.data))
        .catch(error => {
            console.error("There was an error! get word hint", error);
            errCallback(error.response.data)
        });
    }
}

